<template>
  <div>
    <div class="row">
      <div
        v-if="!visaoSimplificada"
        class="col-xs-4 col-sm-3 col-md-2 col-lg-2"
      >
        <div
          :class="{
            'has-error': validations.guia.beneficiario.numeroCarteira.$error,
          }"
          class="form-group"
        >
          <label for="numeroCarteira">8 - Número da carteira</label>
          <input
            id="numeroCarteira"
            v-model="guia.beneficiario.numeroCarteira"
            data-test-id="input-numerocarteira"
            type="text"
            name="numeroCarteira"
            class="form-control"
            placeholder="Número do cartão do beneficiário"
            @input="validations.guia.beneficiario.numeroCarteira.$touch()"
          />
          <span v-if="validations.guia.beneficiario.numeroCarteira.$dirty">
            <span
              v-if="!validations.guia.beneficiario.numeroCarteira.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.beneficiario.numeroCarteira.$params.maxLength
                  .max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-8 col-sm-8 col-md-8 col-lg-8"
      >
        <div
          :class="{ 'has-error': validations.guia.beneficiario.plano.$error }"
          class="form-group"
        >
          <label for="plano">9 - Plano <sup>(1)</sup></label>
          <input
            id="plano"
            v-model="guia.beneficiario.plano"
            data-test-id="input-plano"
            type="text"
            name="plano"
            class="form-control"
            placeholder="Plano do beneficiário"
            @input="validations.guia.beneficiario.plano.$touch()"
          />
          <span v-if="validations.guia.beneficiario.plano.$dirty">
            <span
              v-if="!validations.guia.beneficiario.plano.required"
              class="help-block"
              >Campo obrigatório.</span
            >
            <span
              v-if="!validations.guia.beneficiario.plano.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{ validations.guia.beneficiario.plano.$params.maxLength.max }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-6 col-sm-3 col-md-2 col-lg-2"
      >
        <div
          :class="{
            'has-error': validations.guia.beneficiario.validadeCarteira.$error,
          }"
          class="form-group"
        >
          <label for="validadeCarteira"
            >10 - Validade da carteira <sup>(7)</sup></label
          >
          <input
            id="validadeCarteira"
            v-model="guia.beneficiario.validadeCarteira"
            v-mask="'99/99/9999'"
            data-test-id="input-validadecarteira"
            type="text"
            name="validadeCarteira"
            class="form-control"
            placeholder="Validade da carteira do beneficiário"
          />
          <span v-if="validations.guia.beneficiario.validadeCarteira.$dirty">
            <span
              v-if="!validations.guia.beneficiario.validadeCarteira.valida"
              class="help-block"
              >A carteira do plano está vencida..</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
        <div
          :class="{ 'has-error': validations.guia.beneficiario.nome.$error }"
          class="form-group"
        >
          <label for="nome">11 - Nome <sup>(1)</sup></label>
          <BuscarSelecionar
            :lista="pacientes"
            :selecionado="paciente"
            :exibir="['nome', 'docs_pessoais.cpf']"
            :minimo="1"
            :classes-input="
              visaoSimplificada ? 'form-control input-sm' : 'form-control'
            "
            @selecionar="selecionarPaciente"
            @limpar="limparPaciente"
            @recuperar="recuperarPacientes"
          />
          <span v-if="validations.guia.beneficiario.nome.$dirty">
            <span
              v-if="!validations.guia.beneficiario.nome.required"
              class="help-block"
              >Campo obrigatório.</span
            >
            <span
              v-if="!validations.guia.beneficiario.nome.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{ validations.guia.beneficiario.nome.$params.maxLength.max }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
        <div class="form-group">
          <label for="convenioSelecionado">11a - Convênio utilizado</label>
          <select
            id="convenioSelecionado"
            v-model="guia.beneficiario.convenio"
            data-test-id="select-convenioselecionado"
            :class="{ 'input-sm': visaoSimplificada }"
            class="form-control"
            name="convenioSelecionado"
          >
            <option disabled value="">Selecione</option>
            <option
              v-for="convenio in paciente.convenios"
              :key="convenio._id"
              :value="convenio"
            >
              {{ convenio.nome }}</option
            >
          </select>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-3 col-sm-3 col-md-3 col-lg-3"
      >
        <div
          :class="{
            'has-error':
              validations.guia.beneficiario.numeroCartaoNacionalSaude.$error,
          }"
          class="form-group"
        >
          <label for="numeroCartaoNacionalSaude"
            >12 - Número do cartão nacional de saúde</label
          >
          <input
            id="numeroCartaoNacionalSaude"
            v-model="guia.beneficiario.numeroCartaoNacionalSaude"
            data-test-id="input-numerocartaonacionalsaude"
            type="text"
            name="numeroCartaoNacionalSaude"
            class="form-control"
            placeholder="Número do cartão Nacional de saúde do beneficiário"
            @input="
              validations.guia.beneficiario.numeroCartaoNacionalSaude.$touch()
            "
          />
          <span
            v-if="
              validations.guia.beneficiario.numeroCartaoNacionalSaude.$dirty
            "
          >
            <span
              v-if="
                !validations.guia.beneficiario.numeroCartaoNacionalSaude
                  .maxLength
              "
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.beneficiario.numeroCartaoNacionalSaude.$params
                  .maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <div
            :class="{ 'has-error': validations.guia.pacienteGestante.$error }"
            class="form-group"
          >
            <label for="pacienteGestante"
              >Paciente Gestante <sup>(1)</sup></label
            >
            <select
              id="pacienteGestante"
              v-model="guia.pacienteGestante"
              data-test-id="select-pacientegestante"
              class="form-control"
              name="pacienteGestante"
              @change="validations.guia.pacienteGestante.$touch()"
            >
              <option disabled value="">Selecione</option>
              <option :value="true">Sim</option>
              <option :value="false">Não</option>
            </select>
            <span v-if="validations.guia.pacienteGestante.$dirty">
              <span
                v-if="!validations.guia.pacienteGestante.required"
                class="help-block"
                >Campo obrigatório.</span
              >
            </span>
          </div>
        </div>
        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
          <div
            v-tooltip="
              'Check para Identificar se o Paciente usa CoParticipação.'
            "
            class="checkbox form-group"
            style="margin-top: 27px"
          >
            <label>
              <input
                id="coParticipacao"
                v-model="guia.beneficiario.coParticipacao"
                data-test-id="input-coparticipacao"
                type="checkbox"
                name="coParticipação"
              />
              CoParticipação
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!visaoSimplificada" classs="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="pull-right">
          <RouterLink
            data-test-id="link-auto-8"
            :to="'/paciente/cadastro/'"
            role="button"
            class="btn btn-default"
            ><span class="fa fa-plus" /> Novo paciente</RouterLink
          >
          <RouterLink
            v-if="paciente._id"
            data-test-id="link-auto-9"
            :to="'/paciente/cadastro/' + paciente._id"
            role="button"
            class="btn btn-default"
            ><span class="fa fa-edit" /> Editar paciente</RouterLink
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import PacienteServico from '@/servicos/PacienteServico'

const pacienteServico = new PacienteServico()

export default {
  name: 'DadosBeneficiario',
  components: { BuscarSelecionar },
  directives: { mask: AwesomeMask },
  props: {
    guia: {
      type: Object,
      required: true,
    },
    paciente: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      pacientes: [],
    }
  },
  watch: {
    'guia.beneficiario.convenio'() {
      this.guia.beneficiario.plano = this.guia.beneficiario.convenio.plano
      this.guia.beneficiario.numeroCarteira =
        this.guia.beneficiario.convenio.matricula
      this.guia.beneficiario.validadeCarteira = this.guia.beneficiario.convenio
        .validade
        ? moment(this.guia.beneficiario.convenio.validade).format('DD/MM/YYYY')
        : ''
      this.guia.autorizacao.registroANS = this.guia.beneficiario.convenio.ans
        ? this.guia.beneficiario.convenio.ans
        : 0
    },
  },
  methods: {
    recuperarPacientes(filtro) {
      const data = {
        nome: filtro.palavra,
        ativo: true,
        skip: (filtro.pagina - 1) * filtro.limite,
        limit: filtro.limite,
        orderBy: filtro.chave,
      }

      pacienteServico.recuperarTodos(data).then((result) => {
        this.pacientes = result.pacientes
      })
    },
    selecionarPaciente(paciente) {
      this.$emit('selecionarPaciente', paciente)
    },
    limparPaciente() {
      this.$emit('limparPaciente')
    },
  },
}
</script>
